import dayjs from "dayjs";
import useMediaQuery from "@mui/material/useMediaQuery";
import { FormItemTypes } from "../../../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { EditableDataGrid } from "../../../../../../builderPackage/components/editableDataGrid/editableDataGrid";
import { Stack, Typography } from "@mui/material";
import { DynamicFormBuilderContainer } from "../../../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
export var CourierDetails = function (props) {
    var _value$CourierData2, _value$CourierData$le2, _value$CourierData3;
    var value = props.value, onChange = props.onChange;
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var columns = [{
            type: "singleSelect",
            field: "id",
            headerName: "Sr. No",
            editable: false,
            minWidth: 80,
            renderCell: function (params) { return params.api.getAllRowIds().indexOf(params.id) + 1; }
        }, {
            type: "string",
            field: "CourierName",
            headerName: "Courier Name",
            editable: false,
            minWidth: 180
        }, {
            type: "string",
            field: "DealerName",
            headerName: "Dealer ID",
            editable: false,
            minWidth: 150
        }, {
            type: "string",
            field: "BookingDate",
            headerName: "Booking Date",
            editable: false,
            minWidth: 120
        }, {
            type: "string",
            field: "DocketNumber",
            headerName: "Docket Number",
            editable: false,
            minWidth: 100
        }, {
            type: "string",
            field: "NoOfSample",
            headerName: "No. of Sample",
            editable: true,
            minWidth: 250,
            flex: 1
        }];
    var formData = [{
            type: FormItemTypes.CardComponent,
            name: '',
            sx: {
                border: 0,
                borderRadius: 0
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    sx: {
                        border: "none"
                    },
                    spacing: 0,
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 12,
                            justifyContent: "center",
                            display: "flex",
                            spacing: 0,
                            alignItems: 'center',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: 'ads',
                                    value: 'Courier details',
                                    fontWeight: 'bold',
                                    columnSize: 0
                                }, {
                                    type: FormItemTypes.Chip,
                                    name: "all",
                                    label: '0',
                                    sx: {
                                        ml: 1
                                    },
                                    setFieldProps: function (currentValue) {
                                        var _value$CourierData$le, _value$CourierData;
                                        return {
                                            type: FormItemTypes.Chip,
                                            label: "".concat((_value$CourierData$le = value === null || value === void 0 || (_value$CourierData = value.CourierData) === null || _value$CourierData === void 0 ? void 0 : _value$CourierData.length) !== null && _value$CourierData$le !== void 0 ? _value$CourierData$le : 0)
                                        };
                                    },
                                    columnSize: true,
                                    color: "info"
                                }]
                        }]
                }, {
                    type: FormItemTypes.Accordian,
                    name: 'CourierData',
                    value: false,
                    summaryProps: {
                        sx: {
                            display: 'none'
                        }
                    },
                    summary: [],
                    setFieldProps: function (formValues, currValue, field) {
                        return {
                            type: FormItemTypes.Accordian,
                            expanded: formValues !== null && formValues !== void 0 && formValues.id ? currValue : !currValue
                        };
                    },
                    sx: {
                        border: 'none'
                    },
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.List,
                            name: '',
                            value: value === null || value === void 0 ? void 0 : value.CourierData,
                            columnSize: 12,
                            sx: {
                                mb: 2,
                                mx: 2
                            },
                            disableCheckboxSelection: true,
                            variant: 'compact',
                            columns: [{
                                    field: 'BookingDate',
                                    flex: 1,
                                    renderCell: function (_ref) {
                                        var row = _ref.row;
                                        return /*#__PURE__*/ React.createElement(Stack, {
                                            direction: "row",
                                            justifyContent: 'space-between',
                                            alignItems: "center"
                                        }, /*#__PURE__*/ React.createElement(Typography, {
                                            color: "info"
                                        }, row === null || row === void 0 ? void 0 : row.CourierName), /*#__PURE__*/ React.createElement(Typography, {
                                            p: 1,
                                            fontSize: 'md'
                                        }, "".concat(dayjs(row === null || row === void 0 ? void 0 : row.BookingDate).format('DD MMM, YYYY'))));
                                    }
                                }],
                            elements: [{
                                    type: FormItemTypes.CardComponent,
                                    name: "",
                                    label: "",
                                    columnSize: 12,
                                    sx: {
                                        backgroundColor: 'secondary.50',
                                        m: 1,
                                        border: 0
                                    },
                                    elements: [{
                                            type: FormItemTypes.ContainerItem,
                                            name: '',
                                            columnSize: 12,
                                            spacing: 0,
                                            elements: [{
                                                    type: FormItemTypes.Typography,
                                                    name: 'CourierName',
                                                    label: 'Dealer ID :',
                                                    disabled: true,
                                                    setFieldProps: function (formValues, currValue, field) {
                                                        return {
                                                            type: FormItemTypes.Typography,
                                                            value: formValues === null || formValues === void 0 ? void 0 : formValues.CourierName
                                                        };
                                                    },
                                                    columnSize: 12,
                                                    labelTypographyProps: {
                                                        mb: 0,
                                                        noWrap: true,
                                                        fontWeight: 'medium',
                                                        fontSize: 'sm'
                                                    },
                                                    containerProps: {
                                                        display: 'flex',
                                                        direction: 'row',
                                                        justifyContent: 'space-between'
                                                    }
                                                }, {
                                                    type: FormItemTypes.Typography,
                                                    name: 'DocketNumber',
                                                    label: 'Docker number :',
                                                    disabled: true,
                                                    setFieldProps: function (formValues, currValue, field) {
                                                        return {
                                                            type: FormItemTypes.Typography,
                                                            value: formValues === null || formValues === void 0 ? void 0 : formValues.DocketNumber
                                                        };
                                                    },
                                                    columnSize: 12,
                                                    labelTypographyProps: {
                                                        mb: 0,
                                                        noWrap: true,
                                                        fontWeight: 'medium',
                                                        fontSize: 'sm'
                                                    },
                                                    containerProps: {
                                                        display: 'flex',
                                                        direction: 'row',
                                                        justifyContent: 'space-between'
                                                    }
                                                }, {
                                                    type: FormItemTypes.Typography,
                                                    name: 'NoOfSample',
                                                    label: 'No of sample:',
                                                    disabled: true,
                                                    setFieldProps: function (formValues, currValue, field) {
                                                        return {
                                                            type: FormItemTypes.Typography,
                                                            value: formValues === null || formValues === void 0 ? void 0 : formValues.NoOfSample
                                                        };
                                                    },
                                                    columnSize: 12,
                                                    labelTypographyProps: {
                                                        mb: 0,
                                                        noWrap: true,
                                                        fontWeight: 'medium',
                                                        fontSize: 'sm'
                                                    },
                                                    containerProps: {
                                                        display: 'flex',
                                                        direction: 'row',
                                                        justifyContent: 'space-between'
                                                    }
                                                }]
                                        }]
                                }],
                            getRowHeight: function () { return 'auto'; }
                        }]
                }]
        }];
    return lgMode ? /*#__PURE__*/ React.createElement(EditableDataGrid, {
        columns: columns,
        rows: (_value$CourierData2 = value === null || value === void 0 ? void 0 : value.CourierData) !== null && _value$CourierData2 !== void 0 ? _value$CourierData2 : [],
        disableAddRow: true,
        disableDeleteRow: true,
        disableToolbarActions: true,
        onChange: onChange,
        dataGridHeader: "Courier details",
        isCollapsible: true,
        dataGridProps: {
            initialState: {
                pinnedColumns: {
                    right: ["status"]
                },
                density: "standard"
            },
            hideFooter: true,
            disableColumnMenu: true,
            checkboxSelection: false,
            slotProps: {
                toolbar: {
                    chipLabel: "".concat((_value$CourierData$le2 = value === null || value === void 0 || (_value$CourierData3 = value.CourierData) === null || _value$CourierData3 === void 0 ? void 0 : _value$CourierData3.length) !== null && _value$CourierData$le2 !== void 0 ? _value$CourierData$le2 : 0)
                }
            }
        }
    }) : /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        mode: "edit",
        gridProps: {
            spacing: 0,
            p: 0
        }
    });
};
